/**
 * Copyright Mántum All Rights Reserved.
 */
import { useEffect } from 'react';

export default (callback: () => void, delay: number | null) => {
    useEffect(() => {
        if (delay !== null) {
            const id = setTimeout(callback, delay);
            return () => {
                clearTimeout(id);
            };
        }
    }, [callback, delay]);
};
